import { createFileRoute } from '@tanstack/react-router';
import { auditPeopleQuery, auditQuery } from '@/features/audit/api';
import { AuditPage } from '@/features/audit/pages/AuditPage';
import { auditSearchSchema } from '@/features/audit/search';

export const Route = createFileRoute('/_authed/ops/audit/')({
  staticData: { help: 'audit' },
  validateSearch: auditSearchSchema,
  loaderDeps: ({ search }) => search,
  loader: ({ context: { queryClient }, deps }) => {
    void queryClient.prefetchQuery(auditQuery(deps));
    void queryClient.prefetchQuery(auditPeopleQuery());
  },
  component: AuditPage,
});
